
<div v-if="!isLoading" class="EntityDetailsShifts">
    <ShiftsTable :shifts="shifts" :show-all-trips="false" :container-height="'400px'" />
</div>
